import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
import { baseResourceValidatorSharedMap } from "./SWBaseResource";
/** @public */ export const resourceIdValidator = idValidator("resource_variant");
/** @public */ export function createResourceVariantValidator(type, props, meta) {
    return T.object({
        id: resourceIdValidator,
        typeName: T.literal("resource_variant"),
        type: T.literal(type),
        props: props ? T.object(props) : T.jsonValue,
        meta: meta ? T.object(meta) : T.jsonValue,
        variant: T.string,
        variantVersion: T.number,
        ...baseResourceValidatorSharedMap
    });
}
